import type { CSSProperties, ReactNode } from 'react';

export interface TagBadgeProps {
  icon?: ReactNode;
  children: ReactNode;
  compact?: boolean;
  className?: string;
  style?: CSSProperties;
  title?: string;
}

export function TagBadge({
  icon,
  children,
  compact = false,
  className = '',
  style,
  title,
}: TagBadgeProps) {
  return (
    <span
      className={`inline-flex max-w-full items-center gap-1.5 rounded-full border font-medium leading-tight ${
        compact ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'
      } ${className}`}
      style={style}
      title={title}
    >
      {icon}
      <span className="min-w-0 whitespace-normal break-words">{children}</span>
    </span>
  );
}
